import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputComponent } from './input.component';
import { InputDirective } from './input.directive';
import { InputLabelDirective } from './input-label/input-label.directive';
import { InputErrorDirective } from './input-error/input-error.directive';
import { DatePickerModule } from '../date-picker/date-picker.module';
import { TooltipModule } from '../tooltip/tooltip.module';

@NgModule({
  declarations: [
    InputDirective,
    InputLabelDirective,
    InputErrorDirective,
    InputComponent,
  ],
  imports: [CommonModule, DatePickerModule, TooltipModule],
  exports: [
    InputDirective,
    InputLabelDirective,
    InputErrorDirective,
    InputComponent,
  ],
})
export class InputModule {}
